var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.03,
    height: 22.178,
    viewBox: "0 0 26.03 22.178",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shop-icon",
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M5.785,3.414h19.6L23.6,10.5l-14.2,1.381L4.538.5H0",
    transform: "translate(0 -0.5)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M11.028,14.218,9.515,17.7h14.4",
    transform: "translate(-1.623 -2.84)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M14.52,23.341a1.907,1.907,0,1,1-1.908-1.908A1.908,1.908,0,0,1,14.52,23.341Z",
    transform: "translate(-1.826 -4.07)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M24.823,23.341a1.907,1.907,0,1,1-1.908-1.908A1.908,1.908,0,0,1,24.823,23.341Z",
    transform: "translate(-3.583 -4.07)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon);
export default __webpack_public_path__ + "static/media/shop-icon.85b71f534078220bfbbe05b2ff68a0e7.svg";
export { ForwardRef as ReactComponent };